import React from 'react';
import { useTranslation } from 'react-i18next';
import { useGetReportTopBrands } from '../../hooks/reports/useGetReportTopBrands';
import TopEntitiesCard from './TopEntitiesCard';

const TopBrands = ({ filter, limit = 10 }) => {
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || 'en').startsWith('ar');
    const { items, isLoading } = useGetReportTopBrands({
        from: filter.from,
        to: filter.to,
        limit,
    });

    return (
        <TopEntitiesCard
            title={isArabic ? 'أعلى البراندات مبيعاً' : 'Top brands'}
            items={items}
            isLoading={isLoading}
            color="secondary"
        />
    );
};

export default TopBrands;
